import React, { Component } from 'react'
import { Row, Col, Card } from 'antd'
import './css/DlCard.less'
import imgUrl1 from './icon/icon_db.png'
import imgUrl2 from './icon/icon_zczc.png'
import imgUrl3 from './icon/icon_dqzc.png'
import imgUrl4 from './icon/icon_xx.png'
import imgUrl5 from './icon/icon_qs.png'
import imgUrl6 from './icon/icon_zr.png'


function DlCard(props) {
  const {imgUrl, title, content} = props
  return (
    <Card className="DlCard">
      <div className="left">
        <img src={imgUrl}></img>
      </div>
      <div className="right">
        <div className="title">{title}</div>
        <div className="content">{content}</div>
      </div>
    </Card>
  )
}

export default class TodoList extends Component {
  render() {
    return (
      <Row gutter={[16, 16]} style={{marginBottom: '10px'}}>
        <Col span={8}>
          <DlCard imgUrl={imgUrl1} title={'我的待办'} content={0}></DlCard>
        </Col>
        <Col span={8}>
          <DlCard imgUrl={imgUrl2} title={'我开立的粮信'} content={`￥${(0).toFixed(2)}`}></DlCard>
        </Col>
        <Col span={8}>
          <DlCard imgUrl={imgUrl3} title={'即将到期付款(粮信)'} content={`￥${(0).toFixed(2)}`}></DlCard>
        </Col>
        <Col span={8}>
          <DlCard imgUrl={imgUrl4} title={'我的消息'} content={0}></DlCard>
        </Col>
        <Col span={8}>
          <DlCard imgUrl={imgUrl5} title={'即将到期付款(非粮信)'} content={`￥${(0).toFixed(2)}`}></DlCard>
        </Col>
        <Col span={8}>
          <DlCard imgUrl={imgUrl6} title={'可用授信额度'} content={`￥${(0).toFixed(2)}`}></DlCard>
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/TodoList.js